'use strict';
module.exports = function timeBucket(ts) {
	if (!ts) {
		return 'older';
	}
	const now = new Date(),
		then = new Date(ts);
	if (now.getFullYear() === then.getFullYear()) {
		if (now.getMonth() === then.getMonth()) {
			if (now.getDate() === then.getDate()) {
				return 'same-day';
			} else if (now.getDate() === then.getDate() + 1) {
				return 'last-day';
			} else {
				return 'same-month';
			}
		} else if (now.getMonth() === then.getMonth() + 1) {
			return 'last-month';
		} else {
			return 'same-year';
		}
	} else if (now.getFullYear() === then.getFullYear() + 1) {
		return 'last-year';
	} else {
		return 'older';
	}
};
